"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaChallengeToJSON = exports.MfaChallengeFromJSONTyped = exports.MfaChallengeFromJSON = void 0;
const _1 = require("./");
function MfaChallengeFromJSON(json) {
    return MfaChallengeFromJSONTyped(json, false);
}
exports.MfaChallengeFromJSON = MfaChallengeFromJSON;
function MfaChallengeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'channel': _1.ContactMethodFromJSON(json['channel']),
    };
}
exports.MfaChallengeFromJSONTyped = MfaChallengeFromJSONTyped;
function MfaChallengeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'channel': _1.ContactMethodToJSON(value.channel),
    };
}
exports.MfaChallengeToJSON = MfaChallengeToJSON;
//# sourceMappingURL=MfaChallenge.js.map